import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cmd01000-result-table" }
const _hoisted_2 = { class: "full-width row q-gutter-sm" }
const _hoisted_3 = { class: "q-pt-xs" }
const _hoisted_4 = { class: "add-btn-area flex items-center filter-select" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "q-mb-none" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import axios from '../../common/axios-common';

import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

const DIALOG_LEVEL = 'information';
// ダイアログのtitle
interface MNews {
  news_id: string;
  publish_date: string;
  publication_period_date: string;
  news_title: string;
  browseable_from_login_page: boolean;
  browseable_from_top_page: boolean;
  create_user_name: string;
  create_timestamp: string;
  update_user_name: string;
  update_timestamp: string;
  now_publishing: boolean;
}

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD01000',
  setup(__props) {

const router = useRouter();
// 削除ボタンが押されたお知らせID
const deleteNewsId = ref('');
// ダイアログに表示するお知らせタイトル
const dialogNewsTitle = ref('');
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const dialogTitle = ref('');
// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

const columns = ref<any>([
  {
    name: 'editDelete',
    label: '',
  },
  {
    name: 'publish_date',
    label: '公開開始日時',
    align: 'left',
    field: (row: MNews) => row.publish_date,
    sortable: true,
    style: 'width: 170px',
  },
  {
    name: 'publication_period_date',
    label: '公開終了日時',
    align: 'left',
    field: (row: MNews) => row.publication_period_date,
    sortable: true,
    headerClasses: 'label-publish',
  },
  {
    name: 'news_title',
    label: '件名',
    align: 'left',
    field: (row: MNews) => row.news_title,
    sortable: true,
  },
  {
    name: 'label',
    label: '表示対象',
    align: 'left',
    field: (row: MNews) => row.now_publishing,
    headerClasses: 'label-area',
  },
  {
    name: 'create_user_name',
    label: '登録者',
    align: 'left',
    field: (row: MNews) => row.create_user_name,
    sortable: true,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: (row: MNews) => row.create_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
  {
    name: 'update_user_name',
    label: '更新者',
    align: 'left',
    field: (row: MNews) => row.update_user_name,
    sortable: true,
  },
  {
    name: 'update_timestamp',
    label: '更新日時',
    align: 'left',
    field: (row: MNews) => row.update_timestamp,
    sortable: true,
    style: 'width: 170px',
  },
]);

const rows = ref([
  {
    news_id: '',
    publish_date: '',
    publication_period_date: '',
    news_title: '',
    browseable_from_login_page: false,
    browseable_from_top_page: false,
    create_user_name: '',
    create_timestamp: '',
    update_user_name: '',
    update_timestamp: '',
    now_publishing: false,
  },
]);

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

// お知らせ新規登録に遷移
const registerNews = () => {
  router.push({ name: 'newsRegister', params: { mode: '0' } });
};

// お知らせ情報変更に遷移
const editNews = (newsId: string) => {
  router.push({ name: 'newsEdit', params: { mode: '1', newsId } });
};

// お知らせ一覧取得処理
const viewNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  // お知らせ一覧を取得するController呼び出し
  await axios
    .post('/cmd010001/view')
    .then((res) => {
      const { common, newsList } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          rows.value = newsList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラー画面へ遷移
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 削除確認ダイアログのOKボタン押下時の処理
const deleteNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 削除するお知らせIDをformDataへ
  const formData = new FormData();
  formData.append('news_id', deleteNewsId.value);

  // お知らせ削除処理
  await axios
    .post('/cmd010001/delete', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [`お知らせを削除しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 削除確認のダイアログを表示
const deleteConfDialog = (newsId: string, title: string) => {
  deleteNewsId.value = newsId;
  dialogNewsTitle.value = title;

  // 削除確認ダイアログのtitleを設定
  dialogTitle.value = '削除確認';
  // 削除確認ダイアログのtextを生成
  dialogText.value = [`${dialogNewsTitle.value} を削除します。`, `よろしいですか？`];
  // ダイアログのボタン数判断をfalse(2つ)に
  dialogConfFlg.value = false;
  // ダイアログ表示判断をtrue(表示)に変更
  dialogDisplayFlg.value = true;
};

// 削除完了ダイアログのOKボタン押下時の処理
const dialogComplete = async () => {
  // ダイアログ表示判断をfalse(非表示)に変更
  dialogDisplayFlg.value = false;
  // 一覧を再度表示
  viewNews();
};

// 初期表示処理呼び出し
viewNews();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("お知らせ一覧")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button ' + (rows.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: rows.value,
          columns: columns.value,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                icon: "mdi-plus",
                class: "add-btn",
                color: "primary",
                onClick: registerNews
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("追加")
                ])),
                _: 1
              })
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-label": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "table-btn-area label-area"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(
                  'row items-center ' +
                  (cell.row.browseable_from_login_page && cell.row.browseable_from_top_page
                    ? 'justify-center'
                    : '')
                )
                    }, [
                      _createElementVNode("label", {
                        class: _normalizeClass(
                    (cell.row.browseable_from_login_page ? 'login-label' : 'white-label') +
                    ' q-mr-sm'
                  )
                      }, [
                        (cell.row.browseable_from_login_page)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "ログイン"))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("label", {
                        class: _normalizeClass(cell.row.browseable_from_top_page ? 'top-label' : 'white-label')
                      }, [
                        (cell.row.browseable_from_top_page)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "トップ"))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 2)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "body-cell-publication_period_date": _withCtx((publish) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "label-publish"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass('row items-center ' + (publish.row.now_publishing ? 'justify-center' : ''))
                    }, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(publish.row.publication_period_date), 1),
                      _createElementVNode("label", {
                        class: _normalizeClass(publish.row.now_publishing ? 'publishing-label q-ml-sm' : 'white-label')
                      }, [
                        (publish.row.now_publishing)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "公開中"))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 2)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "table-btn-area delete-btn-exists"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_btn, {
                        icon: "mdi-pencil",
                        color: "primary",
                        onClick: ($event: any) => (editNews(cell.row.news_id))
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" 編集 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_q_btn, {
                        label: "削除",
                        icon: "mdi-close",
                        class: "deletebtn",
                        color: "primary",
                        outline: "",
                        style: {"color":"var(--q-delete)"},
                        onClick: ($event: any) => (deleteConfDialog(cell.row.news_id, cell.row.news_title))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "columns", "hide-no-data", "pagination-label"]),
        _createVNode(AlertDialog, {
          display: dialogDisplayFlg.value,
          level: DIALOG_LEVEL,
          confirmation: dialogConfFlg.value,
          title: dialogTitle.value,
          text: dialogText.value,
          onComplete: _cache[0] || (_cache[0] = ($event: any) => (dialogComplete())),
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (deleteNews())),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (dialogDisplayFlg.value = false))
        }, null, 8, ["display", "confirmation", "title", "text"])
      ], 2)
    ])
  ]))
}
}

})